import styled from "styled-components";

export const Glyph = styled.span`
  &.glyphicon-circle-info {
    margin-left: 15px;
    color: ${({ theme }) => theme.link};
  }
`;
